import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-545c6a10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex col" }
const _hoisted_2 = {
  style: {"width":"50vw","gap":"24px"},
  class: "flex col align-start justify-start"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "Vers quelle base de données voulez vous exporter ces élements : ", -1))
const _hoisted_4 = {
  ref: "container",
  class: "flex col g0 grow scrollbars",
  style: {"overflow":"scroll"}
}
const _hoisted_5 = {
  ref: "stickContainer",
  class: "flex col header-sticky"
}
const _hoisted_6 = { class: "flex justify-between align-center" }
const _hoisted_7 = { class: "flex align-center" }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "flex align-center" }
const _hoisted_10 = { class: "table-container" }
const _hoisted_11 = { ref: "tbody" }
const _hoisted_12 = { class: "f12" }
const _hoisted_13 = { width: "50" }
const _hoisted_14 = {
  style: {"width":"50px"},
  class: "flex align-center justify-center"
}
const _hoisted_15 = { width: "350" }
const _hoisted_16 = {
  style: {"width":"350px"},
  class: "flex justify-between align-center g6"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Nom", -1))
const _hoisted_18 = { width: "100" }
const _hoisted_19 = {
  style: {"width":"100px"},
  class: "flex justify-between align-center g6"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Image", -1))
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "flex justify-between align-center g6" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Type", -1))
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "flex justify-between align-center g6" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Actif", -1))
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { class: "flex justify-between align-center g6" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Relevé de température", -1))
const _hoisted_30 = {
  key: 3,
  width: "130"
}
const _hoisted_31 = {
  style: {"width":"130px"},
  class: "flex justify-between align-center g6"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Température minimum", -1))
const _hoisted_33 = {
  key: 4,
  width: "130"
}
const _hoisted_34 = {
  style: {"width":"130px"},
  class: "flex justify-between align-center g6"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Température maximum", -1))
const _hoisted_36 = { key: 5 }
const _hoisted_37 = { class: "flex justify-between align-center g6" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Etiquette", -1))
const _hoisted_39 = { key: 6 }
const _hoisted_40 = { class: "flex justify-between align-center g6" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, " Tracabilité", -1))
const _hoisted_42 = { key: 7 }
const _hoisted_43 = { class: "flex justify-between align-center g6" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, " Relevé des huiles", -1))
const _hoisted_45 = { key: 8 }
const _hoisted_46 = { class: "flex justify-between align-center g6" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Polaritée Max", -1))
const _hoisted_48 = { key: 9 }
const _hoisted_49 = { class: "flex justify-between align-center g6" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, " Mise en température", -1))
const _hoisted_51 = {
  key: 10,
  width: "130"
}
const _hoisted_52 = {
  style: {"width":"130px"},
  class: "flex justify-between align-center g6"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Température rechauffage", -1))
const _hoisted_54 = {
  key: 11,
  width: "150"
}
const _hoisted_55 = {
  style: {"width":"150px"},
  class: "flex justify-between align-center g6"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Température refroidissement", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Actions", -1))
const _hoisted_58 = ["onClick"]
const _hoisted_59 = { class: "flex col justify-between align-center" }
const _hoisted_60 = { class: "flex justify-between align-center" }
const _hoisted_61 = { class: "flex justify-between align-center" }
const _hoisted_62 = ["onClick", "src"]
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { class: "flex justify-between align-center" }
const _hoisted_65 = { class: "edit-btn" }
const _hoisted_66 = { class: "bold" }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = { class: "flex justify-between align-center" }
const _hoisted_69 = { key: 2 }
const _hoisted_70 = { class: "flex justify-between align-center" }
const _hoisted_71 = { key: 3 }
const _hoisted_72 = { class: "flex justify-between align-center" }
const _hoisted_73 = { key: 4 }
const _hoisted_74 = { class: "flex justify-between align-center" }
const _hoisted_75 = { key: 5 }
const _hoisted_76 = { class: "flex justify-between align-center" }
const _hoisted_77 = { key: 6 }
const _hoisted_78 = { class: "flex justify-between align-center" }
const _hoisted_79 = { key: 7 }
const _hoisted_80 = { class: "flex justify-between align-center" }
const _hoisted_81 = { key: 8 }
const _hoisted_82 = { class: "flex justify-between align-center" }
const _hoisted_83 = { key: 9 }
const _hoisted_84 = { class: "flex justify-between align-center" }
const _hoisted_85 = { key: 10 }
const _hoisted_86 = { class: "flex justify-between align-center" }
const _hoisted_87 = { key: 11 }
const _hoisted_88 = { class: "flex justify-between align-center" }
const _hoisted_89 = { class: "flex div align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeInput = _resolveComponent("SeInput")!
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_SeForm = _resolveComponent("SeForm")!
  const _component_SeModal = _resolveComponent("SeModal")!
  const _component_SeDropdownItem = _resolveComponent("SeDropdownItem")!
  const _component_SeDropdown = _resolveComponent("SeDropdown")!
  const _component_SeCheckBox = _resolveComponent("SeCheckBox")!
  const _component_SeChipList = _resolveComponent("SeChipList")!
  const _component_SearchBar = _resolveComponent("SearchBar")!
  const _component_LockedField = _resolveComponent("LockedField")!
  const _component_SeImage = _resolveComponent("SeImage")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_SeFadeButton = _resolveComponent("SeFadeButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SeModal, {
      ref: "typeModal",
      title: _ctx.Lang.getI18N('edit')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SeForm, {
          ref: "typeForm",
          class: "flex col"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SeInput, {
              ref: "typeName",
              value: "",
              placeholder: _ctx.Lang.getI18N('name'),
              required: ""
            }, null, 8, ["placeholder"]),
            _createVNode(_component_SeButton, {
              class: "modal-valid w100",
              onPress: () => _ctx.createOrEditType()
            }, {
              default: _withCtx(() => [
                _createTextVNode("Ok")
              ]),
              _: 1
            }, 8, ["onPress"])
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_SeModal, {
      title: _ctx.Lang.getI18N('export'),
      ref: "exportModal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_SeDropdown, {
              search: true,
              modelValue: _ctx.state.targetDatabase,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.targetDatabase) = $event)),
              titleFunc: (db) => db.name,
              ref: "dbDropdown",
              class: "w100"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.databases, (database) => {
                  return (_openBlock(), _createBlock(_component_SeDropdownItem, { value: database }, null, 8, ["value"]))
                }), 256))
              ]),
              _: 1
            }, 8, ["modelValue", "titleFunc"]),
            _createVNode(_component_SeCheckBox, { ref: "exportAttachments" }, {
              default: _withCtx(() => [
                _createTextVNode("Exporter les pièces jointes")
              ]),
              _: 1
            }, 512),
            _createVNode(_component_SeButton, {
              onPress: _ctx.exportElements,
              class: "w100"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("export")), 1)
              ]),
              _: 1
            }, 8, ["onPress"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_SeChipList, {
              ref: "chips",
              changed: _ctx.onFilterChange,
              labels: [
            'General',
            'Relevé temp.',
            'Etiquettes',
            'Tracabilitée',
            'Huiles',
            'Mise en temp.',
          ]
            }, null, 8, ["changed"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_SeButton, {
              onPress: _ctx.newElement,
              icon: "ico/plus.svg"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("new-element")), 1)
              ]),
              _: 1
            }, 8, ["onPress"]),
            _createVNode(_component_SeButton, {
              ref: "exportBtn",
              onPress: _ctx.openExportModal,
              icon: "ico/export.svg"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("export")), 1)
              ]),
              _: 1
            }, 8, ["onPress"]),
            _createVNode(_component_SeButton, {
              ref: "saveBtn",
              onPress: _ctx.save,
              icon: "ico/save.svg"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("save")), 1)
              ]),
              _: 1
            }, 8, ["onPress"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_SearchBar, {
            searchChange: _ctx.onSearchChange,
            calm: true,
            class: "grow",
            modelValue: _ctx.state.displayUnactives,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.displayUnactives) = $event)),
            placeholderBase: _ctx.Lang.getI18N('search')
          }, null, 8, ["searchChange", "modelValue", "placeholderBase"])
        ])
      ], 512),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("table", null, [
          _createElementVNode("tbody", _hoisted_11, [
            _createElementVNode("tr", _hoisted_12, [
              _createElementVNode("th", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_SeCheckBox, {
                    ref: "globalCheck",
                    onClick: _ctx.applyGlobalCheck
                  }, null, 8, ["onClick"])
                ])
              ]),
              _createElementVNode("th", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("img", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.revertName && _ctx.revertName(...args))),
                    class: "revert-btn",
                    src: "ico/refresh.svg"
                  })
                ])
              ]),
              _createElementVNode("th", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("img", {
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.revertImage && _ctx.revertImage(...args))),
                    class: "revert-btn",
                    src: "ico/refresh.svg"
                  })
                ])
              ]),
              (_ctx.state.displayColumns.includes('type'))
                ? (_openBlock(), _createElementBlock("th", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("img", {
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.revertType && _ctx.revertType(...args))),
                        class: "revert-btn",
                        src: "ico/refresh.svg"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.displayColumns.includes('active'))
                ? (_openBlock(), _createElementBlock("th", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("img", {
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.revertActive && _ctx.revertActive(...args))),
                        class: "revert-btn",
                        src: "ico/refresh.svg"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.displayColumns.includes('temperatures'))
                ? (_openBlock(), _createElementBlock("th", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("img", {
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.revertTemperatureModule && _ctx.revertTemperatureModule(...args))),
                        class: "revert-btn",
                        src: "ico/refresh.svg"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.displayColumns.includes('minimum-temperature'))
                ? (_openBlock(), _createElementBlock("th", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("img", {
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.revertMinimumTemperature && _ctx.revertMinimumTemperature(...args))),
                        class: "revert-btn",
                        src: "ico/refresh.svg"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.displayColumns.includes('maximum-temperature'))
                ? (_openBlock(), _createElementBlock("th", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _createElementVNode("img", {
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.revertMaximumTemperature && _ctx.revertMaximumTemperature(...args))),
                        class: "revert-btn",
                        src: "ico/refresh.svg"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.displayColumns.includes('labels'))
                ? (_openBlock(), _createElementBlock("th", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createElementVNode("img", {
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.revertLabelModule && _ctx.revertLabelModule(...args))),
                        class: "revert-btn",
                        src: "ico/refresh.svg"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.displayColumns.includes('traceability'))
                ? (_openBlock(), _createElementBlock("th", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _hoisted_41,
                      _createElementVNode("img", {
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.revertTraceabilityModule && _ctx.revertTraceabilityModule(...args))),
                        class: "revert-btn",
                        src: "ico/refresh.svg"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.displayColumns.includes('oils'))
                ? (_openBlock(), _createElementBlock("th", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _createElementVNode("img", {
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.revertOilModule && _ctx.revertOilModule(...args))),
                        class: "revert-btn",
                        src: "ico/refresh.svg"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.displayColumns.includes('maximum-polarity'))
                ? (_openBlock(), _createElementBlock("th", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _hoisted_47,
                      _createElementVNode("img", {
                        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.revertMaximumPolarity && _ctx.revertMaximumPolarity(...args))),
                        class: "revert-btn",
                        src: "ico/refresh.svg"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.displayColumns.includes('temperature_control'))
                ? (_openBlock(), _createElementBlock("th", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _hoisted_50,
                      _createElementVNode("img", {
                        onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.revertTemperatureControlModule && _ctx.revertTemperatureControlModule(...args))),
                        class: "revert-btn",
                        src: "ico/refresh.svg"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.displayColumns.includes('reheating-temperature'))
                ? (_openBlock(), _createElementBlock("th", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _hoisted_53,
                      _createElementVNode("img", {
                        onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.revertReheatingTemperature && _ctx.revertReheatingTemperature(...args))),
                        class: "revert-btn",
                        src: "ico/refresh.svg"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.displayColumns.includes('cooling-temperature'))
                ? (_openBlock(), _createElementBlock("th", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _hoisted_56,
                      _createElementVNode("img", {
                        onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.revertCoolingTemperature && _ctx.revertCoolingTemperature(...args))),
                        class: "revert-btn",
                        src: "ico/refresh.svg"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_57
            ])
          ], 512),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.displayedElements, (element) => {
            return (_openBlock(), _createElementBlock("tr", null, [
              _createElementVNode("td", {
                class: "cell-hover",
                onClick: ($event: any) => (_ctx.onRowClick(element))
              }, [
                _createElementVNode("div", _hoisted_59, [
                  _createVNode(_component_SeCheckBox, {
                    readonly: true,
                    checked: _ctx.checkedElements.includes(element)
                  }, null, 8, ["checked"])
                ])
              ], 8, _hoisted_58),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_60, [
                  _createVNode(_component_SeInput, {
                    inputChange: _ctx.onNameChange,
                    modelValue: element.name,
                    "onUpdate:modelValue": ($event: any) => ((element.name) = $event)
                  }, null, 8, ["inputChange", "modelValue", "onUpdate:modelValue"]),
                  _createVNode(_component_LockedField, {
                    change: _ctx.onNameLockChange,
                    modelValue: element.name_lock,
                    "onUpdate:modelValue": ($event: any) => ((element.name_lock) = $event)
                  }, null, 8, ["change", "modelValue", "onUpdate:modelValue"])
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("img", {
                    class: "illustration",
                    onClick: (e) => _ctx.pickIllustration(e, element),
                    width: "50",
                    src: element.getIcon()
                  }, null, 8, _hoisted_62),
                  _createVNode(_component_LockedField, {
                    change: _ctx.onIllustrationLockChange,
                    modelValue: element.illustration_lock,
                    "onUpdate:modelValue": ($event: any) => ((element.illustration_lock) = $event)
                  }, null, 8, ["change", "modelValue", "onUpdate:modelValue"])
                ])
              ]),
              (_ctx.state.displayColumns.includes('type'))
                ? (_openBlock(), _createElementBlock("td", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, [
                      _createVNode(_component_SeDropdown, {
                        autoResizeMenu: false,
                        onSelectionChanged: _ctx.onTypeChange,
                        titleFunc: (type) => _ctx.state.getTypeName(type),
                        modelValue: element.type,
                        "onUpdate:modelValue": ($event: any) => ((element.type) = $event)
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.types, (type) => {
                            return (_openBlock(), _createBlock(_component_SeDropdownItem, {
                              value: type.ref
                            }, {
                              tailing: _withCtx(() => [
                                _createElementVNode("div", _hoisted_65, [
                                  _createVNode(_component_SeImage, {
                                    onClick: () => _ctx.openEditTaskTypeModal(type),
                                    maxWidth: 18,
                                    maxHeight: 18,
                                    src: "/ico/edit-blue.svg"
                                  }, null, 8, ["onClick"])
                                ])
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 256)),
                          _createVNode(_component_SeDropdownItem, {
                            displayTitle: false,
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.openTypeModalCreation())),
                            class: "noselect"
                          }, {
                            heading: _withCtx(() => [
                              _createElementVNode("span", _hoisted_66, "+ " + _toDisplayString(_ctx.Lang.getI18N("add")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onSelectionChanged", "titleFunc", "modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_LockedField, {
                        change: _ctx.onTypeLockChange,
                        modelValue: element.type_lock,
                        "onUpdate:modelValue": ($event: any) => ((element.type_lock) = $event)
                      }, null, 8, ["change", "modelValue", "onUpdate:modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.displayColumns.includes('active'))
                ? (_openBlock(), _createElementBlock("td", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _createVNode(_component_ToggleSwitch, {
                        click: _ctx.onActiveChange,
                        modelValue: element.active,
                        "onUpdate:modelValue": ($event: any) => ((element.active) = $event)
                      }, null, 8, ["click", "modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_LockedField, {
                        change: _ctx.onActiveLockChange,
                        modelValue: element.active_lock,
                        "onUpdate:modelValue": ($event: any) => ((element.active_lock) = $event)
                      }, null, 8, ["change", "modelValue", "onUpdate:modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.displayColumns.includes('temperatures'))
                ? (_openBlock(), _createElementBlock("td", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      _createVNode(_component_ToggleSwitch, {
                        click: _ctx.onTemperatureModuleChange,
                        modelValue: element.temperatures_module_active,
                        "onUpdate:modelValue": ($event: any) => ((element.temperatures_module_active) = $event)
                      }, null, 8, ["click", "modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_LockedField, {
                        change: _ctx.onTemperatureModuleLockChange,
                        modelValue: element.temperatures_module_active_lock,
                        "onUpdate:modelValue": ($event: any) => ((element.temperatures_module_active_lock) = $event)
                      }, null, 8, ["change", "modelValue", "onUpdate:modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.displayColumns.includes('minimum-temperature'))
                ? (_openBlock(), _createElementBlock("td", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _createVNode(_component_SeInput, {
                        style: {"width":"40px"},
                        numberOnly: true,
                        inputChange: _ctx.onMinimumTemperatureChange,
                        modelValue: element.minimum_temperature,
                        "onUpdate:modelValue": ($event: any) => ((element.minimum_temperature) = $event)
                      }, null, 8, ["inputChange", "modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_LockedField, {
                        change: _ctx.onMinimumTemperatureLockChange,
                        modelValue: element.minimum_temperature_lock,
                        "onUpdate:modelValue": ($event: any) => ((element.minimum_temperature_lock) = $event)
                      }, null, 8, ["change", "modelValue", "onUpdate:modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.displayColumns.includes('maximum-temperature'))
                ? (_openBlock(), _createElementBlock("td", _hoisted_73, [
                    _createElementVNode("div", _hoisted_74, [
                      _createVNode(_component_SeInput, {
                        style: {"width":"40px"},
                        numberOnly: true,
                        inputChange: _ctx.onMaximumTemperatureChange,
                        modelValue: element.maximum_temperature,
                        "onUpdate:modelValue": ($event: any) => ((element.maximum_temperature) = $event)
                      }, null, 8, ["inputChange", "modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_LockedField, {
                        change: _ctx.onMaximumTemperatureLockChange,
                        modelValue: element.maximum_temperature_lock,
                        "onUpdate:modelValue": ($event: any) => ((element.maximum_temperature_lock) = $event)
                      }, null, 8, ["change", "modelValue", "onUpdate:modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.displayColumns.includes('labels'))
                ? (_openBlock(), _createElementBlock("td", _hoisted_75, [
                    _createElementVNode("div", _hoisted_76, [
                      _createVNode(_component_ToggleSwitch, {
                        click: _ctx.onLabelsModuleActiveChange,
                        modelValue: element.labels_module_active,
                        "onUpdate:modelValue": ($event: any) => ((element.labels_module_active) = $event)
                      }, null, 8, ["click", "modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_LockedField, {
                        change: _ctx.onLabelsModuleActiveLockChange,
                        modelValue: element.labels_module_active_lock,
                        "onUpdate:modelValue": ($event: any) => ((element.labels_module_active_lock) = $event)
                      }, null, 8, ["change", "modelValue", "onUpdate:modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.displayColumns.includes('traceability'))
                ? (_openBlock(), _createElementBlock("td", _hoisted_77, [
                    _createElementVNode("div", _hoisted_78, [
                      _createVNode(_component_ToggleSwitch, {
                        click: _ctx.onTraceabilityModuleActiveChange,
                        modelValue: element.traceability_module_active,
                        "onUpdate:modelValue": ($event: any) => ((element.traceability_module_active) = $event)
                      }, null, 8, ["click", "modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_LockedField, {
                        change: _ctx.onTraceabilityModuleActiveLockChange,
                        modelValue: element.traceability_module_active_lock,
                        "onUpdate:modelValue": ($event: any) => ((element.traceability_module_active_lock) = $event)
                      }, null, 8, ["change", "modelValue", "onUpdate:modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.displayColumns.includes('oils'))
                ? (_openBlock(), _createElementBlock("td", _hoisted_79, [
                    _createElementVNode("div", _hoisted_80, [
                      _createVNode(_component_ToggleSwitch, {
                        click: _ctx.onOilModuleActiveChange,
                        modelValue: element.oils_module_active,
                        "onUpdate:modelValue": ($event: any) => ((element.oils_module_active) = $event)
                      }, null, 8, ["click", "modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_LockedField, {
                        change: _ctx.onOilModuleActiveLockChange,
                        modelValue: element.oils_module_active_lock,
                        "onUpdate:modelValue": ($event: any) => ((element.oils_module_active_lock) = $event)
                      }, null, 8, ["change", "modelValue", "onUpdate:modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.displayColumns.includes('maximum-polarity'))
                ? (_openBlock(), _createElementBlock("td", _hoisted_81, [
                    _createElementVNode("div", _hoisted_82, [
                      _createVNode(_component_SeInput, {
                        style: {"width":"40px"},
                        inputChange: _ctx.onMaximumPolarityChange,
                        modelValue: element.maximum_polarity,
                        "onUpdate:modelValue": ($event: any) => ((element.maximum_polarity) = $event),
                        numberOnly: true
                      }, null, 8, ["inputChange", "modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_LockedField, {
                        change: _ctx.onMaximumPolarityLockChange,
                        modelValue: element.maximum_polarity_lock,
                        "onUpdate:modelValue": ($event: any) => ((element.maximum_polarity_lock) = $event)
                      }, null, 8, ["change", "modelValue", "onUpdate:modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.displayColumns.includes('temperature_control'))
                ? (_openBlock(), _createElementBlock("td", _hoisted_83, [
                    _createElementVNode("div", _hoisted_84, [
                      _createVNode(_component_ToggleSwitch, {
                        click: _ctx.onTemperatureControlModuleChange,
                        modelValue: element.temperature_control_module_active,
                        "onUpdate:modelValue": ($event: any) => ((element.temperature_control_module_active) = $event)
                      }, null, 8, ["click", "modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_LockedField, {
                        change: _ctx.onTemperatureControlModuleLockChange,
                        modelValue: element.temperature_control_module_active_lock,
                        "onUpdate:modelValue": ($event: any) => ((element.temperature_control_module_active_lock) = $event)
                      }, null, 8, ["change", "modelValue", "onUpdate:modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.displayColumns.includes('reheating-temperature'))
                ? (_openBlock(), _createElementBlock("td", _hoisted_85, [
                    _createElementVNode("div", _hoisted_86, [
                      _createVNode(_component_SeInput, {
                        style: {"width":"40px"},
                        inputChange: _ctx.onReheatingTemperatureChange,
                        numberOnly: true,
                        modelValue: element.reheating_temperature,
                        "onUpdate:modelValue": ($event: any) => ((element.reheating_temperature) = $event)
                      }, null, 8, ["inputChange", "modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_LockedField, {
                        change: _ctx.onReheatingTemperatureLockChange,
                        modelValue: element.reheating_temperature_lock,
                        "onUpdate:modelValue": ($event: any) => ((element.reheating_temperature_lock) = $event)
                      }, null, 8, ["change", "modelValue", "onUpdate:modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.displayColumns.includes('cooling-temperature'))
                ? (_openBlock(), _createElementBlock("td", _hoisted_87, [
                    _createElementVNode("div", _hoisted_88, [
                      _createVNode(_component_SeInput, {
                        style: {"width":"40px"},
                        numberOnly: true,
                        inputChange: _ctx.onCoolingTemperatureChange,
                        modelValue: element.cooling_temperature,
                        "onUpdate:modelValue": ($event: any) => ((element.cooling_temperature) = $event)
                      }, null, 8, ["inputChange", "modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_LockedField, {
                        change: _ctx.onCoolingTemperatureLockChange,
                        modelValue: element.cooling_temperature_lock,
                        "onUpdate:modelValue": ($event: any) => ((element.cooling_temperature_lock) = $event)
                      }, null, 8, ["change", "modelValue", "onUpdate:modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_89, [
                  _createVNode(_component_SeFadeButton, {
                    onClick: () => _ctx.openElement(element)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("open")), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_SeFadeButton, {
                    onClick: () => _ctx.duplicate(element)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("duplicate")), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ])
            ]))
          }), 256))
        ])
      ])
    ], 512)
  ], 64))
}